import { render } from "./AdminSubmissions.vue?vue&type=template&id=675a6c25&scoped=true"
import script from "./AdminSubmissions.vue?vue&type=script&lang=js"
export * from "./AdminSubmissions.vue?vue&type=script&lang=js"

import "./AdminSubmissions.vue?vue&type=style&index=0&id=675a6c25&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-675a6c25"]])

export default __exports__